const CheckTriangleIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 15L0 0H15V15Z" fill="url(#paint0_linear_0_1)" />
      <path
        d="M12.8333 3.04199L9.62496 6.25033L8.16663 4.79199"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_0_1"
          x1="1.11759e-07"
          y1="15"
          x2="15.2012"
          y2="14.7933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4318F" />
          <stop offset="1" stopColor="#FE3C5F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CheckTriangleIcon;
